<main class="h-[100dvh] md:h-screen overflow-hidden">
    
    <section class="w-full h-full bg-black/80">

        <ng-content/>

    </section>

</main>